import { LinkItem as NavLink } from '../../types/nav'

export function nationalExperiencePageToNavLink(item: {
  title: string
  slug: string
}): NavLink {
  return {
    label: item.title,
    url: `/explore/${item.slug}`,
  }
}
